import { create } from 'zustand';

export type Lang = 'en' | 'ja';

const en = {
  'nav.overview': 'Overview',
  'nav.rooms': 'Rooms',
  'nav.drive': 'Drive',
  'nav.workspace': 'Workspace',
  'nav.members': 'Members',
  'nav.settings': 'Settings',
  'greet.morning': 'Good morning',
  'greet.afternoon': 'Good afternoon',
  'greet.evening': 'Good evening',
  'chip.watching': '{n} watching now',
  'chip.processing': '{n} processing',
  'chip.allReady': 'Library ready',
  'search.placeholder': 'Search drive and rooms',
  'btn.newRoom': 'New room',
  'btn.upload': 'Upload',
  'btn.join': 'Join room',
  'btn.start': 'Start a room',
  'btn.invite': 'Invite',
  'btn.copy': 'Copy link',
  'btn.copied': 'Copied',
  'btn.delete': 'Delete',
  'btn.retry': 'Retry',
  'btn.watch': 'Watch together',
  'btn.cancel': 'Cancel',
  'btn.create': 'Create',
  'btn.signOut': 'Sign out',
  'conn.title': 'Connection',
  'conn.prefer': 'Prefer WebTransport',
  'conn.server': 'Server',
  'conn.media': 'Media relay',
  'conn.clock': 'Clock offset',
  'ov.drive': 'Your drive',
  'ov.library': 'Library',
  'ov.network': 'Network',
  'ov.titles': 'Titles in library',
  'ov.hoursOfVideo': '{h} of video',
  'ov.ready': 'Ready to stream',
  'ov.failed': '{n} failed',
  'ov.watching': 'Watching now',
  'ov.inRooms': 'in {n} rooms',
  'ov.free': 'Free on drive',
  'ov.of': 'of {total}',
  'ov.pipeline': 'Media pipeline',
  'ov.openDrive': 'Drive',
  'ov.recent': 'Library',
  'ov.recentSub': '{n} titles · updated {ago}',
  'ov.latest': 'Latest',
  'ov.all': 'All',
  'ov.rtt': 'Your round trip',
  'ov.rttSub': 'browser ⇄ server',
  'ov.offset': 'Clock offset',
  'ov.offsetSub': 'NTP-style, min-RTT filtered',
  'ov.transport': 'Transport',
  'ov.transportSub': 'QUIC datagrams + streams',
  'ov.members': 'Members',
  'ov.membersSub': '{n} rooms',
  'pipe.uploading': 'Uploading',
  'pipe.queued': 'Queued',
  'pipe.encoding': 'Encoding',
  'pipe.failed': 'Failed',
  'pipe.ready': 'Ready',
  'col.title': 'Title',
  'col.file': 'File',
  'col.source': 'Source',
  'col.quality': 'Quality',
  'col.status': 'Status',
  'col.length': 'Length',
  'src.upload': 'Upload',
  'src.folder': 'Drive folder',
  'bridge.live': 'Live',
  'bridge.empty': 'Nobody is watching right now',
  'bridge.emptySub': 'Start a room and send the invite link. Everyone streams from the drive at their own best quality; only play/pause travels between you.',
  'bridge.inRoom': '{n} in {room}',
  'bridge.note': 'Clock-synced playback · scheduled starts compensate for each person’s latency.',
  'storage.title': 'Drive storage',
  'storage.used': 'of drive used',
  'drive.title': 'Drive',
  'drive.sub': 'Movies, series and clips stored on {label}',
  'drive.drop': 'Drop videos here or browse',
  'drive.dropSub': 'No titles yet — upload from the Drive page, or copy videos into the drive’s inbox folder.',
  'drive.folderHint': 'Or copy files straight into {path} on the drive. They are picked up automatically.',
  'drive.uploads': 'Uploads',
  'drive.paused': 'Paused',
  'drive.resume': 'Resume',
  'drive.pause': 'Pause',
  'drive.encoder': 'Encoder',
  'drive.hw': 'Hardware encoding',
  'rooms.title': 'Rooms',
  'rooms.sub': 'Watch together, share screens, talk.',
  'rooms.empty': 'No rooms yet. Create one and invite someone.',
  'rooms.name': 'Room name',
  'rooms.pick': 'Start with',
  'rooms.nothing': 'Nothing yet (pick later)',
  'rooms.open': 'Join',
  'rooms.idle': 'Idle',
  'room.inRoom': 'In the room',
  'room.chat': 'Chat',
  'room.say': 'Say something…',
  'auth.or': 'or',
  'auth.passkey': 'Sign in with {method}',
  'passkey.title': 'Face ID & fingerprint',
  'passkey.lead': 'Sign in with this device\'s {method} instead of your password. Your face or fingerprint never leaves the device.',
  'passkey.add': 'Set up {method} on this device',
  'passkey.added': '{method} sign-in is set up on this device',
  'passkey.none': 'No devices yet.',
  'passkey.unavailable': "This browser or device can't use Face ID / fingerprint sign-in.",
  'passkey.remove': 'Remove',
  'passkey.lastUsed': 'last used {when}',
  'passkey.neverUsed': 'not used yet',
  'passkey.nudge': 'Sign in faster next time with {method}',
  'passkey.nudgeLater': 'Not now',
  'passkey.thisPhone': 'this phone',
  'passkey.leadPhone': "Your phone's own face or fingerprint unlock signs you in: one tap, no password. It works only while this phone is unlocked.",
  'passkey.signInWith': 'Sign in with',
  'set.mode': 'Light & dark',
  'set.modeSub': 'Follow this device, or always use one. It applies on every device you use.',
  'set.modeSystem': 'Device',
  'set.modeLight': 'Light',
  'set.modeDark': 'Dark',
  'passkey.face': 'face unlock',
  'passkey.faceTab': 'Face unlock',
  'passkey.fingerprint': 'fingerprint',
  'passkey.fingerprintTab': 'Fingerprint',
  'passkey.faceHint': 'One tap: your phone is already unlocked with your face.',
  'passkey.fingerprintHint': 'Asks for your fingerprint every time.',
  'push.title': 'Notifications on this device',
  'push.appUpdate': 'Update the Android app (Settings → App) to get notifications.',
  'push.lead': 'Get a notification when someone invites you to a room, even when Video Bridge is closed.',
  'push.on': 'Notifications are on for this device',
  'push.onShort': 'On: room invites reach you even when Video Bridge is closed',
  'push.off': 'Get notified when someone invites you',
  'push.turnOn': 'Turn on',
  'push.turnOff': 'Turn off',
  'push.enabled': 'Notifications are on',
  'push.blocked': 'Notifications are blocked for Video Bridge. Allow them in your browser or phone settings.',
  'push.install': 'To get notifications on iPhone, add Video Bridge to your Home Screen (Share → Add to Home Screen) and open it from there.',
  'push.unsupported': "This browser can't show notifications.",
  'notes.title': 'Notifications',
  'appUpdate.copyLink': 'Copy the update link',
  'appUpdate.copied': 'Link copied — paste it into Chrome to download the update',
  'appUpdate.copyFailed': "Couldn't copy the link — open bridge.mohamedfuad.com in Chrome and update from Settings → App",
  'appUpdate.oldAppSteps': 'This version of the app can\'t install updates itself (the new one can). Copy the link, open Chrome, paste it in the address bar, then open the download and tap Update. You only do this once.',
  'notes.appUpdate': 'Android app {v} is ready',
  'notes.appUpdateSub': 'Install it to get the newest features',
  'notes.close': 'Close',
  'notes.markRead': 'Mark all read',
  'notes.more': 'Show {n} more',
  'notes.less': 'Show less',
  'notes.forYou': 'For you',
  'notes.liveNow': 'Watching now',
  'notes.library': 'Library',
  'notes.invite': '{name} invites you to watch',
  'notes.update': 'A new version is ready',
  'notes.updateSub': 'Takes a second; you stay signed in',
  'notes.updateNow': 'Update',
  'notes.whatsNew': 'Updated: here’s what’s new',
  'notes.pending': '{n} waiting to join the team',
  'notes.pendingSub': 'Add them on the Team page',
  'notes.failed': '{n} titles couldn’t be prepared',
  'notes.failedOne': '1 title couldn’t be prepared',
  'notes.failedSub': 'Retry from the Drive',
  'notes.watching': '{names} watching',
  'notes.working': 'Preparing {n} titles',
  'notes.workingOne': 'Preparing 1 title',
  'notes.workingSub': 'They play as soon as the original is in',
  'notes.capture': 'Recording network data',
  'notes.captureSub': 'Settings → Network',
  'notes.newFilm': 'New in the library',
  'notes.allClear': "You're all caught up",
  'notes.allClearSub': 'Invites, new films and anything that needs you shows up here.',
  'invite.title': 'Invite to “{room}”',
  'invite.sub': 'They get a pop-up in Video Bridge right away and join with one tap.',
  'invite.nobody': 'No one else is in the team yet.',
  'invite.inside': 'In this room',
  'invite.offline': 'Not in the app right now',
  'invite.here': 'Here',
  'invite.sent': 'Invited',
  'invite.sentOne': 'Invite sent',
  'invite.sentMany': 'Invited {n} people',
  'invite.everyone': 'Invite everyone ({n})',
  'invite.orLink': 'Or copy the room link',
  'invite.popup': '{name} invites you to watch',
  'invite.notNow': 'Not now',
  'invite.leavesCurrent': 'Joining leaves the room you are in',
  'room.join': 'Join room',
  'rooms.youreIn': "You're in this room",
  'room.leave': 'Leave',
  'room.backToRoom': 'Back to the room',
  'room.backToRooms': 'All rooms',
  'room.notFound': "This room doesn't exist any more",
  'room.nothingPicked': 'Nothing picked yet',
  'room.oneInside': '{name} is inside',
  'room.manyInside': '{n} people are inside',
  'room.empty': 'Nobody is inside yet',
  'room.switchNote': 'You are in “{name}”. Joining this room leaves it.',
  'set.app': 'App',
  'set.network': 'Network',
  'room.syncTitle': 'Sync & connection',
  'room.testConnection': 'Test my connection',
  'draw.title': 'Draw on the picture (everyone sees it)',
  'draw.pen': 'Pen',
  'draw.eraser': 'Eraser: tap a mark to remove it',
  'draw.undo': 'Undo my last mark',
  'draw.clear': 'Clear marks',
  'draw.done': 'Stop drawing',
  'room.voiceReady': 'Voice is ready · talk, share, or both',
  'room.voiceConnecting': 'Connecting voice…',
  'room.talking': 'Mic on: {names}',
  'room.tapToHear': 'Tap to hear everyone',
  'room.micOn': 'Mic on',
  'room.micOff': 'Talk',
  'voice.settings': 'Voice settings',
  'voice.isolation': 'Voice isolation',
  'voice.isolationSub': 'Keeps only your voice; background noise and other people near you are removed',
  'voice.echo': 'Echo cancellation',
  'voice.echoSub': 'What your speakers play doesn’t come back through your mic (off with headphones for fuller sound)',
  'voice.autoGain': 'Auto volume',
  'voice.autoGainSub': 'Evens out your mic level',
  'voice.duck': 'Voices over app sounds',
  'voice.duckSub': 'The film and shared sound get quieter while someone talks',
  'voice.duckLevel': 'App sounds while talking',
  'voice.duckLow': 'Low',
  'voice.duckHalf': 'Half',
  'voice.duckHigh': 'High',
  'voice.ptt': 'Push to talk',
  'voice.pttSub': 'Your mic sends only while you hold a key',
  'voice.pttKey': 'Key',
  'voice.pressKey': 'Press a key…',
  'voice.hold': 'Hold {key}',
  'voice.talking': 'Talking',
  'voice.level': 'Mic level',
  'room.adaptive': 'Adaptive',
  'room.fullQuality': 'Full quality',
  'room.maxHere': 'Up to {size} from this device',
  'room.cantShareHere': "This browser can't share its screen. Voice works; share from a computer or the Android app.",
  'room.uploadHurts': 'An upload from this device is using your upload speed; your share will be blurry.',
  'room.react': 'React',
  'room.chatEmpty': 'No messages yet. Say hi 👋',
  'room.typing1': '{name} is typing…',
  'room.typing2': '{a} and {b} are typing…',
  'room.typingMany': '{n} people are typing…',
  'room.chatSoundOn': 'Turn on message sounds',
  'room.chatSoundOff': 'Mute message sounds',
  'room.library': 'Up next',
  'room.policy': 'When someone buffers',
  'room.linkField': 'Room link',
  'net.captureNote': 'Note for this capture',
  'room.together': 'Wait together',
  'room.independent': 'Keep playing',
  'room.lock': 'Only host controls playback',
  'room.share': 'Share screen',
  'room.stopShare': 'Stop sharing',
  'room.sharp': 'Sharp text',
  'room.offsetSub': 'Best of the last {n} time checks',
  'chat.attach': 'Attach a file (up to 50 MB)',
  'chat.tooBig': 'That file is {size}; files can be up to 50 MB',
  'chat.uploading': 'Uploading',
  'chat.removeFile': 'Remove the file',
  'chat.drop': 'Drop to send in the chat',
  'chat.expired': 'Expired: files are kept for 7 days',
  'chat.download': 'Download',
  'room.look': 'Look',
  'room.quality': 'Quality',
  'room.resolution': 'Size',
  'room.fps': 'Frame rate',
  'room.bitrate': 'Bitrate',
  'room.sound': 'Sound',
  'room.auto': 'Auto',
  'room.full': 'Full',
  'room.soundOn': 'Shared',
  'room.soundOff': 'Muted',
  'room.shareSettings': 'More share settings',
  'room.liveTitle': 'Live settings',
  'room.liveHint': 'Changes apply instantly',
  'room.noSoundShort': 'No sound in this share',
  'room.sending': 'Sending {size} · {fps} fps · {rate} Mbit/s',
  'room.switchSource': 'Change window or screen',
  'room.smooth': 'Smooth motion',
  'room.mic': 'Mic',
  'room.pickTitle': 'Pick something to watch',
  'room.pickSub': 'Choose a title from the drive on the right. Everyone streams it from the server at their own best quality.',
  'room.tapToJoin': 'Tap to join playback',
  'room.tapSub': 'Your browser needs one tap before it can play sound.',
  'room.inSync': 'In sync',
  'room.waitingFor': 'Waiting for {names}…',
  'room.scheduled': 'Starting together…',
  'room.drift': 'Drift',
  'room.driftSub': 'you vs room clock',
  'room.offset': 'Clock offset',
  'room.rtt': 'Round trip',
  'room.rttSub': 'to server',
  'room.transport': 'Transport',
  'room.media': 'Voice & screen',
  'room.mediaOffline': 'Media relay offline',
  'room.inviteTitle': 'Invite to {room}',
  'room.inviteSub': 'Anyone with this link can join for 72 hours. Send it over a private chat.',
  'room.host': 'Host',
  'room.you': 'you',
  'status.watching': 'watching',
  'status.buffering': 'buffering',
  'status.catching-up': 'catching up',
  'status.idle': 'idle',
  'join.invited': 'You’re invited',
  'join.setup': 'Set up your bridge',
  'join.setupSub': 'You’ll be the owner of this server. Invite family and friends next.',
  'join.from': '{name} from {city} invited you',
  'join.toRoom': 'to {room}',
  'join.name': 'Your name',
  'join.city': 'Where are you?',
  'join.go': 'Join the bridge',
  'join.invalid': 'This invite link is invalid or has expired. Ask for a new one.',
  'welcome.title': 'Video Bridge',
  'welcome.sub': 'Watch together across countries. Ask the server owner for an invite link to get in.',
  'settings.title': 'Settings',
  'settings.profile': 'Profile',
  'settings.language': 'Language',
  'settings.connection': 'Sync transport',
  'settings.server': 'Server',
  'settings.invite': 'Invite people',
  'settings.inviteSub': 'Creates a link valid for 72 hours.',
  'settings.device': 'Open on another device',
  'settings.signinLinkField': 'Sign-in link',
  'settings.androidLinkField': 'Android app download link',
  'settings.quickLinkField': 'Free public link',
  'settings.certFile': 'Certificate file (fullchain.pem)',
  'settings.keyFile': 'Private key file (privkey.pem)',
  'settings.livekitUrl': 'LiveKit Cloud URL',
  'settings.livekitKey': 'LiveKit API key',
  'settings.livekitSecret': 'LiveKit API secret',
  'settings.deviceSub': 'A link that signs you in as yourself on another device or browser. Anyone with a 7-day link can use it until it expires, so keep it private.',
  'settings.short': '15 min · one-time',
  'settings.week': '7 days · reusable',
  'settings.deviceBtn': 'Create sign-in link',
  'signin.working': 'Signing you in…',
  'signin.invalid': 'This sign-in link is invalid, expired or already used. Create a new one from Settings.',
  'nav.team': 'Team',
  'nav.logs': 'Logs',
  'nav.collapse': 'Collapse sidebar',
  'nav.expand': 'Expand sidebar',
  'auth.signIn': 'Sign in',
  'auth.signUp': 'Create account',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.newPassword': 'New password',
  'auth.name': 'Your name',
  'auth.city': 'City',
  'art.title': 'Movie night, across any distance.',
  'art.sub': "The bridge's server streams the film to everyone in the room. Press play in Delhi and it starts on the same frame in Tokyo, London and New York.",
  'loc.label': 'Where you watch from',
  'loc.country': 'Country',
  'loc.anyCountry': 'Any country',
  'loc.placeholder': 'City or postal code',
  'loc.none': 'No places found. Try a city name, or check the country.',
  'auth.forgot': 'Forgot password?',
  'auth.haveAccount': 'Already have an account?',
  'auth.noAccount': 'New here?',
  'auth.welcomeBack': 'Welcome back',
  'auth.joinTitle': 'Join the bridge',
  'auth.joinSub': 'Create your account, then the host adds you to the team.',
  'auth.pwHint': 'At least 8 characters, with letters and numbers.',
  'auth.resetTitle': 'Reset your password',
  'auth.resetSent': 'If that email has an account, a reset link is on its way.',
  'auth.resetNoEmail': 'Email isn’t set up on this server yet — ask the host for a reset link.',
  'auth.verifyTitle': 'Confirming your email…',
  'auth.verified': 'Email confirmed',
  'auth.verifyBanner': 'Confirm your email address to join the team. Check your inbox for {email}.',
  'auth.resend': 'Resend email',
  'wait.title': 'Almost there',
  'wait.sub': 'You’re signed in. The host needs to add you to the team before you can watch.',
  'wait.shareId': 'Share your ID with the host',
  'wait.invites': 'Invitations',
  'wait.accept': 'Accept',
  'wait.decline': 'Decline',
  'wait.none': 'No invitations yet. This page updates by itself.',
  'wait.codeField': 'Invitation code',
  'wait.copyId': 'Copy your ID',
  'team.title': 'Team',
  'team.sub': '{n} members · the drive is shared with everyone in the team',
  'team.invite': 'Invite people',
  'team.searchPh': 'Search by ID (VB-…), email or name',
  'team.byEmail': 'Invite by email',
  'team.emailField': 'Email address to invite',
  'team.link': 'Invite link',
  'team.createLink': 'Create invite link',
  'team.pending': 'Pending invitations',
  'team.waiting': 'People waiting',
  'team.waitingSub': 'Signed up but not in the team yet.',
  'team.outbox': 'Email outbox',
  'team.outboxSub': 'Email isn’t set up — share these links yourself.',
  'team.add': 'Add to team',
  'team.invited': 'Invited',
  'team.member': 'In team',
  'team.verify': 'Mark verified',
  'team.remove': 'Remove',
  'team.online': 'online',
  'team.inRoom': 'watching',
  'perm.drive': 'Drive',
  'perm.upload': 'Upload',
  'perm.control': 'Controls',
  'perm.share': 'Screen share',
  'perm.rooms': 'Start rooms',
  'perm.trash': 'Trash',
  'perm.invite': 'Invite',
  'set.profile': 'Profile',
  'set.appearance': 'Appearance',
  'set.themeSub': 'Pick your accent colour. It follows your account to every device.',
  'set.security': 'Security',
  'set.changePw': 'Change password',
  'set.currentPw': 'Current password',
  'set.server': 'Server',
  'set.storage': 'Drive & storage',
  'set.public': 'Public access',
  'set.email': 'Email (SMTP)',
  'set.screen': 'Screen share & voice',
  'set.background': 'Background service',
  'set.save': 'Save',
  'set.saved': 'Saved',
  'set.restart': 'Restart server',
  'set.avatar': 'Change picture',
  'set.yourId': 'Your ID',
  'speed.title': 'Connection to host',
  'speed.sub': 'Measures the path the video and screen share actually travel: this device ⇄ the server.',
  'speed.run': 'Test my connection',
  'speed.again': 'Test again',
  'speed.down': 'Download',
  'speed.up': 'Upload',
  'speed.ping': 'Ping',
  'speed.verdict': 'You can stream',
  'logs.title': 'Logs',
  'logs.sub': 'Everything the server and everyone’s browsers reported, kept for 30 days.',
  'logs.live': 'Live',
  'logs.download': 'Download',
  'logs.search': 'Search logs',
  'drive.offline': 'The host’s drive isn’t connected. Playback and uploads resume as soon as it’s plugged back in.',
  'setup.title': 'Set up Video Bridge',
  'setup.ddnsToken': 'Vercel API token',
  'setup.ddnsDomain': 'Domain for dynamic DNS',
  'members.title': 'Members',
  'members.sub': 'People who can use this server',
  'common.owner': 'Host',
  'common.member': 'Member',
} as const;

export type Key = keyof typeof en;

const ja: Partial<Record<Key, string>> = {
  'nav.overview': '概要',
  'nav.rooms': 'ルーム',
  'nav.drive': 'ドライブ',
  'nav.workspace': 'ワークスペース',
  'nav.members': 'メンバー',
  'nav.settings': '設定',
  'greet.morning': 'おはようございます',
  'greet.afternoon': 'こんにちは',
  'greet.evening': 'こんばんは',
  'chip.watching': '{n}人が視聴中',
  'chip.processing': '{n}件 処理中',
  'chip.allReady': 'ライブラリ準備完了',
  'search.placeholder': 'ドライブとルームを検索',
  'btn.newRoom': '新しいルーム',
  'btn.upload': 'アップロード',
  'btn.join': 'ルームに参加',
  'btn.start': 'ルームを作成',
  'btn.invite': '招待',
  'btn.copy': 'リンクをコピー',
  'btn.copied': 'コピーしました',
  'btn.delete': '削除',
  'btn.retry': '再試行',
  'btn.watch': '一緒に見る',
  'btn.cancel': 'キャンセル',
  'btn.create': '作成',
  'btn.signOut': 'サインアウト',
  'conn.title': '接続',
  'conn.prefer': 'WebTransport を優先',
  'conn.server': 'サーバー',
  'conn.media': 'メディア中継',
  'conn.clock': '時計のずれ',
  'ov.drive': 'あなたのドライブ',
  'ov.library': 'ライブラリ',
  'ov.network': 'ネットワーク',
  'ov.titles': 'ライブラリの作品',
  'ov.hoursOfVideo': '合計 {h}',
  'ov.ready': '再生可能',
  'ov.failed': '{n}件 失敗',
  'ov.watching': '視聴中',
  'ov.inRooms': '{n}ルーム',
  'ov.free': 'ドライブ空き容量',
  'ov.of': '全体 {total}',
  'ov.pipeline': 'メディア処理',
  'ov.openDrive': 'ドライブ',
  'ov.recent': 'ライブラリ',
  'ov.recentSub': '{n}作品 · {ago}に更新',
  'ov.latest': '最新',
  'ov.all': 'すべて',
  'ov.rtt': '往復遅延',
  'ov.rttSub': 'ブラウザ ⇄ サーバー',
  'ov.offset': '時計のずれ',
  'ov.offsetSub': 'NTP方式・最小RTTで補正',
  'ov.transport': '通信方式',
  'ov.transportSub': 'QUIC データグラム + ストリーム',
  'ov.members': 'メンバー',
  'ov.membersSub': '{n}ルーム',
  'pipe.uploading': 'アップロード中',
  'pipe.queued': '待機中',
  'pipe.encoding': 'エンコード中',
  'pipe.failed': '失敗',
  'pipe.ready': '準備完了',
  'col.title': 'タイトル',
  'col.file': 'ファイル',
  'col.source': '取得元',
  'col.quality': '画質',
  'col.status': '状態',
  'col.length': '長さ',
  'src.upload': 'アップロード',
  'src.folder': 'ドライブフォルダ',
  'bridge.live': 'ライブ',
  'bridge.empty': '現在視聴中の人はいません',
  'bridge.emptySub': 'ルームを作って招待リンクを送りましょう。各自がドライブから最適な画質で再生し、再生・停止だけが同期されます。',
  'bridge.inRoom': '{room} に {n}人',
  'bridge.note': '時計同期再生 · 各自の遅延を見込んで同時にスタートします。',
  'storage.title': 'ドライブ容量',
  'storage.used': '使用中',
  'drive.title': 'ドライブ',
  'drive.sub': '{label} に保存された映画・シリーズ・動画',
  'drive.drop': 'ここに動画をドロップ、または選択',
  'drive.dropSub': 'まだ作品がありません。ドライブページからアップロードするか、受信フォルダにコピーしてください。',
  'drive.folderHint': 'ドライブの {path} に直接コピーしても自動で取り込まれます。',
  'drive.uploads': 'アップロード',
  'drive.paused': '一時停止中',
  'drive.resume': '再開',
  'drive.pause': '一時停止',
  'drive.encoder': 'エンコーダー',
  'drive.hw': 'ハードウェアエンコード',
  'rooms.title': 'ルーム',
  'rooms.sub': '一緒に見る・画面共有・会話。',
  'rooms.empty': 'ルームはまだありません。作成して誰かを招待しましょう。',
  'rooms.name': 'ルーム名',
  'rooms.pick': '最初に見る作品',
  'rooms.nothing': 'あとで選ぶ',
  'rooms.open': '参加',
  'rooms.idle': '待機中',
  'room.inRoom': '参加者',
  'room.chat': 'チャット',
  'room.say': 'メッセージを入力…',
  'auth.or': 'または',
  'auth.passkey': '{method}でログイン',
  'passkey.title': 'Face ID と指紋認証',
  'passkey.lead': 'パスワードの代わりに、この端末の{method}でログインできます。顔や指紋の情報が端末の外に出ることはありません。',
  'passkey.add': 'この端末で{method}を設定',
  'passkey.added': 'この端末で{method}ログインを設定しました',
  'passkey.none': 'まだ登録された端末はありません。',
  'passkey.unavailable': 'このブラウザや端末では Face ID / 指紋ログインを使えません。',
  'passkey.remove': '削除',
  'passkey.lastUsed': '最終使用 {when}',
  'passkey.neverUsed': '未使用',
  'passkey.nudge': '次回から{method}ですばやくログイン',
  'passkey.nudgeLater': '今はしない',
  'passkey.thisPhone': 'この端末',
  'passkey.leadPhone': 'この端末の顔認証や指紋でロックを解除していれば、ワンタップでログインできます。パスワードは不要で、ロック解除中だけ使えます。',
  'passkey.signInWith': 'ログイン方法',
  'set.mode': 'ライト / ダーク',
  'set.modeSub': 'この端末の設定に合わせるか、どちらかに固定します。お使いのすべての端末に反映されます。',
  'set.modeSystem': '端末に合わせる',
  'set.modeLight': 'ライト',
  'set.modeDark': 'ダーク',
  'passkey.face': '顔認証',
  'passkey.faceTab': '顔認証',
  'passkey.fingerprint': '指紋',
  'passkey.fingerprintTab': '指紋',
  'passkey.faceHint': 'ワンタップ：端末はすでに顔認証でロック解除されています。',
  'passkey.fingerprintHint': '毎回指紋認証を求めます。',
  'push.title': 'この端末の通知',
  'push.appUpdate': '通知を受け取るには Android アプリを更新してください（設定 → アプリ）。',
  'push.lead': 'Video Bridge を閉じていても、ルームに招待されたら通知が届きます。',
  'push.on': 'この端末の通知はオンです',
  'push.onShort': 'オン: Video Bridge を閉じていても招待が届きます',
  'push.off': '招待されたら通知を受け取る',
  'push.turnOn': 'オンにする',
  'push.turnOff': 'オフにする',
  'push.enabled': '通知をオンにしました',
  'push.blocked': 'Video Bridge の通知がブロックされています。ブラウザか端末の設定で許可してください。',
  'push.install': 'iPhone で通知を受け取るには、Video Bridge をホーム画面に追加（共有 → ホーム画面に追加）して、そこから開いてください。',
  'push.unsupported': 'このブラウザは通知を表示できません。',
  'notes.title': 'お知らせ',
  'appUpdate.copyLink': '更新リンクをコピー',
  'appUpdate.copied': 'リンクをコピーしました。Chrome に貼り付けてダウンロードしてください',
  'appUpdate.copyFailed': 'リンクをコピーできませんでした。Chrome で bridge.mohamedfuad.com を開き、設定 → アプリから更新してください',
  'appUpdate.oldAppSteps': 'このバージョンのアプリは自分で更新できません（新しいバージョンはできます）。リンクをコピーして Chrome のアドレス欄に貼り付け、ダウンロードしたファイルを開いて「更新」をタップしてください。この操作は一度だけです。',
  'notes.appUpdate': 'Android アプリ {v} を利用できます',
  'notes.appUpdateSub': 'インストールして最新の機能を使いましょう',
  'notes.close': '閉じる',
  'notes.markRead': 'すべて既読',
  'notes.more': 'さらに{n}件を表示',
  'notes.less': '閉じる',
  'notes.forYou': 'あなたへ',
  'notes.liveNow': '視聴中',
  'notes.library': 'ライブラリ',
  'notes.invite': '{name}さんから視聴のお誘い',
  'notes.update': '新しいバージョンがあります',
  'notes.updateSub': 'すぐに終わり、ログインはそのままです',
  'notes.updateNow': '更新',
  'notes.whatsNew': '更新しました：新機能',
  'notes.pending': '{n}人がチームへの参加待ち',
  'notes.pendingSub': 'チームページで追加',
  'notes.failed': '{n}件の作品を準備できませんでした',
  'notes.failedOne': '1件の作品を準備できませんでした',
  'notes.failedSub': 'ドライブから再試行',
  'notes.watching': '{names}が視聴中',
  'notes.working': '{n}件の作品を準備中',
  'notes.workingOne': '1件の作品を準備中',
  'notes.workingSub': 'オリジナルが届けばすぐ再生できます',
  'notes.capture': 'ネットワークを記録中',
  'notes.captureSub': '設定 → ネットワーク',
  'notes.newFilm': 'ライブラリに追加',
  'notes.allClear': 'すべて確認済み',
  'notes.allClearSub': '招待や新しい作品など、お知らせはここに表示されます。',
  'invite.title': '「{room}」に招待',
  'invite.sub': 'Video Bridge にすぐ通知が届き、ワンタップで参加できます。',
  'invite.nobody': 'チームにまだ他のメンバーがいません。',
  'invite.inside': 'このルームにいます',
  'invite.offline': '今はアプリを開いていません',
  'invite.here': '参加中',
  'invite.sent': '招待済み',
  'invite.sentOne': '招待を送りました',
  'invite.sentMany': '{n}人を招待しました',
  'invite.everyone': '全員を招待（{n}人）',
  'invite.orLink': 'またはルームのリンクをコピー',
  'invite.popup': '{name}さんから視聴のお誘い',
  'invite.notNow': '今はしない',
  'invite.leavesCurrent': '参加すると今のルームから退出します',
  'room.join': 'ルームに参加',
  'rooms.youreIn': '参加中',
  'room.leave': '退出',
  'room.backToRoom': 'ルームに戻る',
  'room.backToRooms': 'ルーム一覧',
  'room.notFound': 'このルームはもうありません',
  'room.nothingPicked': 'まだ何も選ばれていません',
  'room.oneInside': '{name}さんが参加中',
  'room.manyInside': '{n}人が参加中',
  'room.empty': 'まだ誰もいません',
  'room.switchNote': '「{name}」に参加中です。このルームに参加すると退出します。',
  'set.app': 'アプリ',
  'set.network': 'ネットワーク',
  'room.syncTitle': '同期と接続',
  'room.testConnection': '接続をテスト',
  'draw.title': '画面に描く（全員に表示）',
  'draw.pen': 'ペン',
  'draw.eraser': '消しゴム: 線をタップして消す',
  'draw.undo': '自分の最後の線を取り消す',
  'draw.clear': '線を消去',
  'draw.done': '描くのをやめる',
  'room.voiceReady': '音声の準備完了 · 話す・共有・両方OK',
  'room.voiceConnecting': '音声に接続中…',
  'room.talking': 'マイクオン: {names}',
  'room.tapToHear': 'タップしてみんなの声を聞く',
  'room.micOn': 'マイクオン',
  'room.micOff': '話す',
  'voice.settings': '音声の設定',
  'voice.isolation': '声の分離',
  'voice.isolationSub': 'あなたの声だけを残し、周りの雑音や近くの人の声を消します',
  'voice.echo': 'エコー除去',
  'voice.echoSub': 'スピーカーの音がマイクに戻りません（ヘッドホンならオフで自然な音に）',
  'voice.autoGain': '自動音量',
  'voice.autoGainSub': 'マイクの音量をそろえます',
  'voice.duck': '話し声を優先',
  'voice.duckSub': '誰かが話している間、映画や共有の音を小さくします',
  'voice.duckLevel': '話している間のアプリの音',
  'voice.duckLow': '小さく',
  'voice.duckHalf': '半分',
  'voice.duckHigh': '大きめ',
  'voice.ptt': 'プッシュトゥトーク',
  'voice.pttSub': 'キーを押している間だけマイクが送られます',
  'voice.pttKey': 'キー',
  'voice.pressKey': 'キーを押してください…',
  'voice.hold': '{key} を押して話す',
  'voice.talking': '話し中',
  'voice.level': 'マイクの音量',
  'room.adaptive': '自動調整',
  'room.fullQuality': '最高画質',
  'room.maxHere': 'この端末から最大 {size}',
  'room.cantShareHere': 'このブラウザでは画面共有できません。音声は使えます。共有はパソコンかAndroidアプリから。',
  'room.uploadHurts': 'この端末のアップロードが回線を使っているため、共有がぼやけます。',
  'room.react': 'リアクション',
  'room.chatEmpty': 'まだメッセージはありません。あいさつしよう 👋',
  'room.typing1': '{name}さんが入力中…',
  'room.typing2': '{a}さんと{b}さんが入力中…',
  'room.typingMany': '{n}人が入力中…',
  'room.chatSoundOn': 'メッセージ音をオンにする',
  'room.chatSoundOff': 'メッセージ音をミュート',
  'room.library': '次に見る',
  'room.policy': '誰かが読み込み中のとき',
  'room.linkField': 'ルームのリンク',
  'net.captureNote': 'このキャプチャのメモ',
  'room.together': '全員で待つ',
  'room.independent': '再生を続ける',
  'room.lock': 'ホストのみ操作可能',
  'room.share': '画面を共有',
  'room.stopShare': '共有を停止',
  'room.sharp': '文字くっきり',
  'room.offsetSub': '直近{n}回の時刻チェックから',
  'chat.attach': 'ファイルを添付（50 MBまで）',
  'chat.tooBig': 'このファイルは {size} です。50 MB までのファイルを送れます',
  'chat.uploading': 'アップロード中',
  'chat.removeFile': 'ファイルを外す',
  'chat.drop': 'ドロップしてチャットに送信',
  'chat.expired': '期限切れ: ファイルの保存は7日間です',
  'chat.download': 'ダウンロード',
  'room.look': '見え方',
  'room.quality': '画質',
  'room.resolution': 'サイズ',
  'room.fps': 'フレーム',
  'room.bitrate': 'ビットレート',
  'room.sound': '音声',
  'room.auto': '自動',
  'room.full': '最大',
  'room.soundOn': '共有中',
  'room.soundOff': 'ミュート',
  'room.shareSettings': '共有の詳細設定',
  'room.liveTitle': 'ライブ設定',
  'room.liveHint': '変更はすぐ反映',
  'room.noSoundShort': 'この共有に音声はありません',
  'room.sending': '送信中 {size} · {fps} fps · {rate} Mbit/s',
  'room.switchSource': 'ウィンドウや画面を変更',
  'room.smooth': '動きなめらか',
  'room.mic': 'マイク',
  'room.pickTitle': '見る作品を選んでください',
  'room.pickSub': '右のドライブから作品を選びます。各自がサーバーから最適な画質で再生します。',
  'room.tapToJoin': 'タップして再生に参加',
  'room.tapSub': '音声を再生するにはブラウザで一度タップが必要です。',
  'room.inSync': '同期中',
  'room.waitingFor': '{names} を待っています…',
  'room.scheduled': '同時にスタートします…',
  'room.drift': 'ずれ',
  'room.driftSub': 'ルームの時計との差',
  'room.offset': '時計のずれ',
  'room.rtt': '往復遅延',
  'room.rttSub': 'サーバーまで',
  'room.transport': '通信方式',
  'room.media': '音声と画面',
  'room.mediaOffline': 'メディア中継オフライン',
  'room.inviteTitle': '{room} に招待',
  'room.inviteSub': 'このリンクは72時間有効です。個別のチャットで送ってください。',
  'room.host': 'ホスト',
  'room.you': 'あなた',
  'status.watching': '視聴中',
  'status.buffering': '読み込み中',
  'status.catching-up': '追いつき中',
  'status.idle': '待機',
  'join.invited': '招待が届いています',
  'join.setup': 'ブリッジを設定',
  'join.setupSub': 'あなたがこのサーバーのオーナーになります。次に家族や友人を招待しましょう。',
  'join.from': '{city}の{name}さんからの招待',
  'join.toRoom': '{room} へ',
  'join.name': 'お名前',
  'join.city': 'どこにいますか？',
  'join.go': 'ブリッジに参加',
  'join.invalid': 'この招待リンクは無効か期限切れです。新しいリンクをもらってください。',
  'welcome.title': 'Video Bridge',
  'welcome.sub': '国を越えて一緒に見よう。サーバーのオーナーから招待リンクをもらってください。',
  'settings.title': '設定',
  'settings.profile': 'プロフィール',
  'settings.language': '言語',
  'settings.connection': '同期の通信方式',
  'settings.server': 'サーバー',
  'settings.invite': '招待する',
  'settings.inviteSub': '72時間有効なリンクを作成します。',
  'settings.device': '別の端末で開く',
  'settings.signinLinkField': 'サインインリンク',
  'settings.androidLinkField': 'Android アプリのダウンロードリンク',
  'settings.quickLinkField': '無料の公開リンク',
  'settings.certFile': '証明書ファイル (fullchain.pem)',
  'settings.keyFile': '秘密鍵ファイル (privkey.pem)',
  'settings.livekitUrl': 'LiveKit Cloud の URL',
  'settings.livekitKey': 'LiveKit の API キー',
  'settings.livekitSecret': 'LiveKit の API シークレット',
  'settings.deviceSub': '別の端末やブラウザであなたとしてサインインできるリンクです。7日間リンクは期限まで誰でも使えるので、他人に共有しないでください。',
  'settings.short': '15分・1回限り',
  'settings.week': '7日間・繰り返し可',
  'settings.deviceBtn': 'サインインリンクを作成',
  'signin.working': 'サインインしています…',
  'signin.invalid': 'このサインインリンクは無効・期限切れ・使用済みです。設定から新しく作成してください。',
  'nav.team': 'チーム',
  'nav.logs': 'ログ',
  'auth.signIn': 'サインイン',
  'auth.signUp': 'アカウント作成',
  'auth.email': 'メールアドレス',
  'auth.password': 'パスワード',
  'auth.name': 'お名前',
  'auth.city': '都市',
  'art.title': 'どれだけ離れていても、同じ映画の夜を。',
  'art.sub': 'ブリッジのサーバーから部屋の全員に映画を配信します。デリーで再生すると、東京でもロンドンでもニューヨークでも同じ場面から始まります。',
  'loc.label': '視聴する場所',
  'loc.country': '国',
  'loc.anyCountry': 'すべての国',
  'loc.placeholder': '都市名または郵便番号',
  'loc.none': '見つかりませんでした。都市名で検索するか、国を確認してください。',
  'auth.forgot': 'パスワードを忘れた場合',
  'auth.welcomeBack': 'おかえりなさい',
  'auth.joinTitle': 'ブリッジに参加',
  'auth.joinSub': 'アカウントを作成すると、ホストがチームに追加します。',
  'auth.verifyBanner': 'チームに参加するにはメールアドレスを確認してください（{email}）。',
  'auth.resend': '再送信',
  'wait.title': 'もう少しです',
  'wait.sub': 'サインインしました。視聴するにはホストがチームに追加する必要があります。',
  'wait.shareId': 'ホストにIDを伝えてください',
  'wait.invites': '招待',
  'wait.accept': '参加する',
  'wait.decline': '辞退',
  'wait.codeField': '招待コード',
  'wait.copyId': 'IDをコピー',
  'team.title': 'チーム',
  'team.invite': 'メンバーを招待',
  'team.searchPh': 'ID（VB-…）、メール、名前で検索',
  'team.emailField': '招待するメールアドレス',
  'team.add': 'チームに追加',
  'perm.drive': 'ドライブ',
  'perm.upload': 'アップロード',
  'perm.control': '再生操作',
  'perm.share': '画面共有',
  'perm.rooms': 'ルーム作成',
  'perm.trash': 'ゴミ箱',
  'perm.invite': '招待',
  'set.profile': 'プロフィール',
  'set.appearance': '外観',
  'set.themeSub': 'アクセントカラーを選択します。アカウントに保存され、すべての端末で使われます。',
  'set.security': 'セキュリティ',
  'set.server': 'サーバー',
  'set.save': '保存',
  'speed.title': 'ホストへの接続',
  'speed.run': '接続をテスト',
  'speed.down': 'ダウンロード',
  'speed.up': 'アップロード',
  'speed.verdict': '視聴できる画質',
  'logs.title': 'ログ',
  'logs.search': 'ログを検索',
  'drive.offline': 'ホストのドライブが接続されていません。接続されるとすぐに再開します。',
  'setup.title': 'Video Bridge のセットアップ',
  'setup.ddnsToken': 'Vercel API トークン',
  'setup.ddnsDomain': 'ダイナミック DNS のドメイン',
  'members.title': 'メンバー',
  'members.sub': 'このサーバーを使える人',
  'common.owner': 'ホスト',
  'common.member': 'メンバー',
};

const dicts: Record<Lang, Partial<Record<Key, string>>> = { en, ja };

function initialLang(): Lang {
  try {
    const saved = localStorage.getItem('vb.lang');
    if (saved === 'en' || saved === 'ja') return saved;
  } catch {
    /* ignore */
  }
  return navigator.language.startsWith('ja') ? 'ja' : 'en';
}

export const useLang = create<{ lang: Lang; setLang: (l: Lang, remember?: boolean) => void }>((set) => ({
  lang: initialLang(),
  setLang: (lang, remember = true) => {
    if (remember) {
      try {
        localStorage.setItem('vb.lang', lang);
      } catch {
        /* ignore */
      }
    }
    document.documentElement.lang = lang;
    set({ lang });
  },
}));

export function useT() {
  const lang = useLang((s) => s.lang);
  return (key: Key, vars?: Record<string, string | number>) => {
    let s: string = dicts[lang][key] ?? en[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
    return s;
  };
}
